import { PayPalScriptProvider } from '@paypal/react-paypal-js'
import { CommonPaypalRestButton } from 'common/components/entities/paypal-rest-button'
import { BorderType } from 'common/types/styleTypes'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import FieldErrors from 'publisher/components/FieldErrors'
import {
  handleValidateSubscription,
  usePaypalRestPaymentHandler,
} from 'publisher/hooks/payment/use-paypal-rest-payment-handler'
import { usePayment } from 'publisher/store'
import { isOrderBumpChecked } from 'publisher/store/payment/paymentSelectors'
import React, { memo } from 'react'
import { PaymentButtonEntityInterface } from 'src/shared/entities/payment-button/payment-button.schema'
import { PaypalBackgroundColorType } from 'src/shared/schemas/payment/paypal-background-color.schema'

export interface PaypalRestSubscriptionButtonProps {
  entity: PaymentButtonEntityInterface
  currency: string
  backgroundColor?: PaypalBackgroundColorType
  borderRadius?: Partial<BorderType>
}

const PaypalRestSubscriptionButton = ({
  entity,
  currency,
  backgroundColor,
  borderRadius,
}: PaypalRestSubscriptionButtonProps) => {
  const { handleSubmit, errors, isLoading, orderHash } =
    usePaypalRestPaymentHandler(entity)
  const isBumpChecked = usePayment(isOrderBumpChecked)

  return (
    <PayPalScriptProvider
      options={{
        clientId: `${process.env.PAYPAL_CLIENT_ID}`,
        currency: currency.toLocaleUpperCase(),
        vault: true,
        intent: 'subscription',
      }}
    >
      <StyleWrapper
        flex
        flexColumn
        margin={entity.margin}
        mobileMargin={entity.mobileMargin}
        appearance={entity.appearance || { desktop: true, mobile: true }}
      >
        <CommonPaypalRestButton
          createSubscription={async () => (await handleSubmit()) as string}
          onApprove={async data => {
            await handleValidateSubscription(data, orderHash, isBumpChecked)
          }}
          borderRadius={borderRadius}
          backgroundColor={backgroundColor}
          disabled={isLoading}
        />
        <FieldErrors errors={errors} align="center" />
      </StyleWrapper>
    </PayPalScriptProvider>
  )
}

export default memo(PaypalRestSubscriptionButton)
